module.exports = __webpack_public_path__ + "static/media/text_museum.a73cb230.svg";